var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 14.2a1 1 0 010 2H4a1 1 0 010-2h8zM8.5 0L13 7.2l-1.71 6H4.7L3 7.2 7.5 0v6.29a1.5 1.5 0 101 0V0z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMTIgMTQuMmExIDEgMCAwIDEgMCAySDRhMSAxIDAgMCAxIDAtMmg4ek04LjUgMEwxMyA3LjJsLTEuNzEgNkg0LjdMMyA3LjIgNy41IDB2Ni4yOWExLjUgMS41IDAgMSAwIDEgMFYweiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgContactSupport as ReactComponent };